import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import Spinner from "../../../base/components/Spinner";
import { ProjectModel } from "../../../base/models/projectModel";
import { fetchProjects } from "../../../base/service/service";
import { formatDate } from "../../../base/utils/formatDate";

interface Props {
  setActiveTab: (idx: number) => void;
  setSelectedProject: (idx: ProjectModel) => void;
}

const AllProjectsView = ({
  setActiveTab,
  setSelectedProject,
}: Props) => {
  const [projects, setProjects] = useState<ProjectModel[]>();

  useEffect(() => {
    const fetchData = async () => {
      const data = await fetchProjects({admin : true});
      // console.log(data)
      setProjects(data);
    };

    fetchData();
  }, []);

  return (
    <div className="flex-auto">
      {projects ? (
        <>
          <table className="w-full">
            <thead>
              <tr className="font-bold">
                <td>Project</td>
                <td >Category</td>
                <td className="hidden lg:table-cell">Framework</td>
                <td className="hidden md:table-cell">isActive?</td>
                <td className="hidden lg:table-cell">Latest Update</td>
                <td className="hidden xl:table-cell">Created At</td>
                <td>Edit</td>
              </tr>
            </thead>
            <tbody>
              {projects.map((e,idx) => (
                <tr key={idx} className="font-medium hover:bg-gray-300">
                  <td className="py-2 border-b border-gray-500">{e.title}</td>
                  <td className="py-2 border-b border-gray-500">
                    {e.category.name}
                  </td>
                  <td className="py-2 border-b border-gray-500">
                    {e.framework.name}
                  </td>
                  <td className="py-2 border-b border-gray-500 hidden md:table-cell">
                    {!e.isDeactive ? buildGreenDot() : buildRedDot()}
                  </td>
                  <td className="py-2 border-b border-gray-500 hidden lg:table-cell">
                    {formatDate(e.latestUpdate)}
                  </td>
                  <td className="py-2 border-b border-gray-500 hidden xl:table-cell">
                    {formatDate(e.createdDate)}
                  </td>
                  <td className="py-2 border-b border-gray-500 text-indigo-800">
                    <button
                      onClick={() => {
                        setSelectedProject(e);
                        setActiveTab(2);
                      }}
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="flex flex-row my-4 justify-end gap-1">
            <span className="font-medium">Total</span>
            <span className="font-medium">{projects.length} items</span>
          </div>
        </>
      ) : (
        <Spinner />
      )}
    </div>
  );
};

export default AllProjectsView;

function buildRedDot() {
  return <div className="w-4 h-4 rounded-full bg-red-300"></div>;
}

function buildGreenDot() {
  return <div className="w-4 h-4 rounded-full bg-green-500"></div>;
}
